// src/components/page/videoList/VideoItemsList.tsx
import React from "react";
import { SimpleGrid } from '@mantine/core';
import { VideoItem } from '@/components/Video/VideoItem';
import type { VideoItemData } from '@/types/video';

type Props = {
    items?: Array<VideoItemData | null | undefined>;
    premiereVideo?: Array<VideoItemData | null | undefined>;
};

export const VideoItemsList: React.FC<Props> = ({ items = [], premiereVideo = [] }) => (
    <>
        {premiereVideo.length > 0 && (
            <div className="video__list--premiere">
                <SimpleGrid cols={{ base: 1, sm: 2, md: 3, lg: 4 }} spacing="md" mb="lg">
                    {premiereVideo.filter(Boolean).map((item) => (
                        <VideoItem key={(item as VideoItemData).id} item={item as VideoItemData} />
                    ))}
                </SimpleGrid>
            </div>
        )}

        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
            {items.filter(Boolean).map((item) => (
                <VideoItem key={(item as VideoItemData).id} item={item as VideoItemData} />
            ))}
        </SimpleGrid>
    </>
);
